import store from "../../index.js";
import OrderdeterminedConstant from "@/mixins/order/const/orderDeterminedConstant.js";
import OrderdeterminedAcConstant from "@/mixins/order/const/orderDeterminedAcConstant.js";
import api from "../../../utils/api.js";

export const modules = {
  store,
};

export const state = {
  _items: {
    contract_type: null,
    contract_date: null,
    deposit_amount: 0,
    rental_amount: 0,
    address: null,
    address_jibun: null,
    address_dong: null,
    address_gu: null,
    address_li: null,
    address_si: null,
    building_code: null,
    building_name: null,
    building_number: null,
    building_dong: null,
    building_floor: null,
    building_ho: null,
    joint_yn: null,
    order_seq: null,
    merchant: null,
  },
  _error: {},
};

export const mutations = {
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_SEQ]: (state, payload) => {
    state._items.order_seq = payload;
  },
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_MERCHANT]: (state, payload) => {
    state._items.merchant = payload;
  },
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_TYPE]: (state, payload) => {
    state._items.contract_type = payload;
  },
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_PRICE]: (state, payload) => {
    state._items.deposit_amount = payload.deposit_amount;
    state._items.rental_amount = payload.rental_amount;
  },
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_DATE]: (state, payload) => {
    state._items.contract_date = payload;
  },
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_ADDRESS]: (state, payload) => {
    state._items.address = payload.address;
    state._items.address_jibun = payload.address_jibun;
    state._items.address_dong = payload.address_dong;
    state._items.address_gu = payload.address_gu;
    state._items.address_li = payload.address_li;
    state._items.address_si = payload.address_si;
    state._items.building_code = payload.building_code;
    state._items.building_name = payload.building_name;
    state._items.building_number = payload.building_number;
    state._items.joint_yn = payload.joint_yn;
  },
  [OrderdeterminedConstant.ADD_ORDER_DETERMINED_BUILDING]: (state, payload) => {
    state._items.building_dong = payload.building_dong;
    state._items.building_floor = payload.building_floor;
    state._items.building_ho = payload.building_ho;
  },
  [OrderdeterminedConstant.ADD_DETERMINED_ERROR]: (state, payload) => {
    state._error = { code: 0, message: "" };
    state._error = payload;
  },
  [OrderdeterminedConstant.DELETE_DETERMINED]: state => {
    (state._items.contract_type = null),
      (state._items.contract_date = null),
      (state._items.deposit_amount = 0),
      (state._items.rental_amount = 0),
      (state._items.address = null),
      (state._items.address_jibun = null),
      (state._items.address_dong = null),
      (state._items.address_gu = null),
      (state._items.address_li = null),
      (state._items.address_si = null),
      (state._items.building_code = null),
      (state._items.building_name = null),
      (state._items.building_number = null),
      (state._items.building_dong = null),
      (state._items.building_floor = null),
      (state._items.building_ho = null),
      (state._items.joint_yn = null),
      (state._items.order_seq = null),
      (state._items.merchant = null);
  },
};

// NZSC-3871: 주소확정 4종 공통 요청.
//
// ① 대상(order_seq / merchant_uid)은 **URL 로만** 나간다. body 에 남기면 api-public 의
//    ValidationPipe(forbidNonWhitelisted) 가 DTO 밖 필드로 보고 400 을 낸다. 종전 merchant
//    경로가 merchant 만 빼내고 order_seq 를 body 에 남겨 30일간 65건이 여기서 죽었다.
// ② 실패를 false 가 아니라 **사유 코드**로 돌려준다. 호출부가 false 만 받던 시절에는
//    화면이 공용 오류 페이지로 보낼 수밖에 없었고, 그 화면이 확정 상태를 초기화해
//    재시도가 계속 실패하는 순환을 만들었다.
async function postDeterminedConfirm(commit, url, payload) {
  const body = { ...payload };
  delete body.order_seq;
  delete body.merchant;

  try {
    const res = await api.post(url, body);
    if (res?.data?.code !== 0) {
      return { success: false, code: res?.data?.code ?? null };
    }
    // report_code = 다방 웹뷰 브릿지 'address_confirmed' payload 용.
    return { success: true, report_code: res.data?.data?.report_code ?? null };
  } catch (error) {
    // ensureErrorResponse 가 네트워크 실패에도 response 를 채워주지만 data 는 null 이다.
    const data = error?.response?.data ?? null;
    if (data) commit(OrderdeterminedConstant.ADD_DETERMINED_ERROR, data);
    return { success: false, code: data?.code ?? null, status: error?.response?.status ?? 0 };
  }
}

export const actions = {
  async acOrderDeterminedAddress({ commit }, payload) {
    const url = OrderdeterminedAcConstant.POST_ORDER_DETERMINED_ADDRESS;
    return postDeterminedConfirm(commit, `${url}/${payload.order_seq}`, payload);
  },
  async acOrderDeterminedBuilding({ commit }, payload) {
    const url = OrderdeterminedAcConstant.POST_ORDER_DETERMINED_BUILDING;
    return postDeterminedConfirm(commit, `${url}/${payload.order_seq}`, payload);
  },
  async acOrderDeterminedAddressByMerchant({ commit }, payload) {
    const url = OrderdeterminedAcConstant.POST_ORDER_DETERMINED_ADDRESS_BY_MERCHANT;
    return postDeterminedConfirm(commit, `${url}/${payload.merchant}`, payload);
  },
  async acOrderDeterminedBuildingByMerchant({ commit }, payload) {
    const url = OrderdeterminedAcConstant.POST_ORDER_DETERMINED_BUILDING_BY_MERCHANT;
    return postDeterminedConfirm(commit, `${url}/${payload.merchant}`, payload);
  },
  async acOrderDeterminedModifyMinute({ commit }, payload) {
    const url = OrderdeterminedAcConstant.POST_ORDER_DETERMINED_MINUTE_MODIFY;
    try {
      const { order_seq, ...param } = payload;
      const res = await api.post(`${url}/${order_seq}`, { ...param });
      return res?.data?.code === 0 ? true : false;
    } catch (error) {
      commit(OrderdeterminedConstant.ADD_DETERMINED_ERROR, error.response.data);
      return false;
    }
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 2511:
        return "수정시간 5분이 지났습니다.";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
